// extracted by mini-css-extract-plugin
export default {"wineItem":"MenuItems_wineItem__AWmaS","vodkaItem":"MenuItems_vodkaItem__x-Huq","foodItem":"MenuItems_foodItem__vpstv"};